import { jsx } from "react/jsx-runtime";
import { CallToActionButton } from "./CallToActionButton.js";
import { CardIcon } from "./CardIcon.js";
import { FeatureRow } from "./FeatureRow.js";
import { HeaderTile } from "./HeaderTile.js";
import { MarkdownGroup } from "./MarkdownGroup.js";
function ContentGroup({
  backgroundColor,
  content,
  featureConfig,
  primaryColor,
  secondaryColor,
  isDisableLinks = false
}) {
  var _a, _b;
  if (!content) {
    return null;
  }
  if ("icon_block" in content) {
    const iconImage = (_b = (_a = content.icon_block) == null ? void 0 : _a.icon_image) == null ? void 0 : _b[0];
    return /* @__PURE__ */ jsx(CardIcon, { url: iconImage.url });
  }
  if ("button_block" in content) {
    return /* @__PURE__ */ jsx(CallToActionButton, { buttonBlock: content.button_block });
  }
  if ("markdown_text" in content) {
    return /* @__PURE__ */ jsx(
      MarkdownGroup,
      {
        content: content.markdown_text,
        primaryColor,
        isDisableLinks
      }
    );
  }
  if ("feature_icons" in content) {
    return /* @__PURE__ */ jsx(
      FeatureRow,
      {
        backgroundColor,
        primaryColor,
        row: content.feature_icons,
        secondaryColor
      }
    );
  }
  if ("tile_block" in content) {
    return /* @__PURE__ */ jsx(
      HeaderTile,
      {
        colorConfig: featureConfig == null ? void 0 : featureConfig.tile_color,
        content
      }
    );
  }
}
export {
  ContentGroup
};
